import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';

import { IProperty } from '@shared/models/properties';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  selectPropertiesCount,
  selectPropertiesErrors,
} from '@state/properties/properties.selectors';

@UntilDestroy()
@Component({
  selector: 'app-home-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
})
export class ListViewComponent implements OnInit, OnChanges {
  @Input({ required: true }) loading = false;
  @Input({ required: true }) isLoggedIn = false;
  @Input({ required: true }) properties?: IProperty[];

  protected shareModalProperty: IProperty | undefined = undefined;
  protected showingProperties: IProperty[] = [];
  protected showingLastProperty = false;

  protected isMobile = false;
  protected hasErrors = false;
  protected propertiesPerPage = 20;
  protected count$: Observable<number | undefined> = this.store.select(
    selectPropertiesCount
  );

  constructor(
    private store: Store<AppState>,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.store
      .select(selectPropertiesErrors)
      .pipe(untilDestroyed(this))
      .subscribe((errors) => {
        this.hasErrors = errors;
      });

    this.updateShowingProperties();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['properties']) {
      this.updateShowingProperties();
    }
  }

  trackByFn(index: number, item: IProperty): string {
    return item.id;
  }

  handleShowMore(): void {
    const propertiesLength = this.showingProperties.length;
    const propertiesLengthTotal = this.properties?.length || 0;
    const propertiesLengthToSlice = propertiesLength + this.propertiesPerPage;

    if (propertiesLengthToSlice >= propertiesLengthTotal) {
      this.showingLastProperty = true;
    }

    this.showingProperties = this.properties
      ? this.properties.slice(0, propertiesLengthToSlice)
      : [];
  }

  private updateShowingProperties(): void {
    this.showingProperties = this.properties
      ? this.properties.slice(0, this.propertiesPerPage)
      : [];
    this.showingLastProperty =
      this.showingProperties.length >= (this.properties?.length || 0);
  }
}
